export default "__VITE_ASSET__BAAG3GEa__"